(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9161],{

/***/ 71364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83126);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31857);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42586);
/* harmony import */ var _assets_403_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84999);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const MobileException = props => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const errorMap = {
    '403': {
      title: t['403.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['403.subtitle']
    },
    '404': {
      title: t['404.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['404.subtitle']
    },
    '500': {
      title: t['500.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['500.subtitle']
    },
    [_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .NOT_VERIFIED */ .MC]: {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_assets_403_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
      title: t['403.title'],
      subTitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        style: {
          fontSize: '16px',
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          children: t['exception.not.verified1']
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          children: t['exception.not.verified2']
        })]
      })
    }
  };
  const error = errorMap[props.code];
  const is500WithRetry = props.code === '500' && !router.pathname.startsWith('/500');
  const buttonProps = is500WithRetry ? {
    onClick: () => {
      router.reload();
    },
    children: t['exception.retry']
  } : {
    onClick: () => {
      router.replace('/board');
    },
    children: t['back.home']
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().result),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default())[`bg${props.code}`]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().title),
        children: error.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().subtitle),
        children: error.subTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread({
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_6___default().btn)
      }, buttonProps))]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MobileException);

/***/ }),

/***/ 75069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_mobile_es_components_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18758);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _styles_index_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83599);
/* harmony import */ var _styles_index_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_index_module_less__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const GuideToPC = props => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const {
    0: visible,
    1: setVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setVisible(true);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (_styles_index_module_less__WEBPACK_IMPORTED_MODULE_3___default().container),
    children: [props.children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd_mobile_es_components_modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      visible: visible,
      className: (_styles_index_module_less__WEBPACK_IMPORTED_MODULE_3___default().modal),
      title: t['monitor.jump.tip'],
      content: t['guide.toPC'],
      closeOnAction: true,
      closeOnMaskClick: true,
      onClose: () => {
        setVisible(false);
      },
      actions: [{
        key: 'close',
        text: t['modal.close'],
        className: (_styles_index_module_less__WEBPACK_IMPORTED_MODULE_3___default().close)
      }]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GuideToPC);

/***/ }),

/***/ 46129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_403_2_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51931);
/* harmony import */ var _assets_404_2_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76333);
/* harmony import */ var _assets_500_2_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65395);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83126);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9205);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_less__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42586);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74169);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25617);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72160);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62258);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















const Exception = props => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  const {
    userInfo
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(state => state.global);
  const {
    email
  } = userInfo;
  const {
    0: loading,
    1: setLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const errorMap = {
    '403': {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_403_2_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
      title: t['403.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['403.subtitle']
    },
    '404': {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_404_2_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
      title: t['404.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['404.subtitle']
    },
    '405': {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        status: "warning"
      }),
      title: '',
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['title.405']
    },
    '500': {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_500_2_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
      title: t['500.title'],
      subTitle: (props === null || props === void 0 ? void 0 : props.message) || t['500.subtitle']
    },
    [_utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .NOT_VERIFIED */ .MC]: {
      bg: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_403_2_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
      title: t['403.title'],
      subTitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        style: {
          fontSize: '16px',
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          children: t['exception.not.verified1']
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          children: t['exception.not.verified2']
        })]
      })
    }
  };
  const error = errorMap[props.code];
  const is500WithRetry = props.code === '500' && !router.pathname.startsWith('/500');
  const isNotVerified = props.code === _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .NOT_VERIFIED */ .MC;
  const buttonProps = is500WithRetry ? {
    onClick: () => {
      router.reload();
    },
    children: t['exception.retry']
  } : isNotVerified ? {
    onClick: () => {
      if (email) {
        setLoading(true);
        (0,_api_common__WEBPACK_IMPORTED_MODULE_7__/* .updateUserEmailApi */ .mF)({
          email
        }).then(res => {
          if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .SUCCESS_CODE */ .Gh) {
            _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].success */ .Z.success(t['userSetting.email.verify']);
          }
        }).finally(() => {
          setLoading(false);
        });
      }
    },
    children: t['exception.send.email']
  } : {
    onClick: () => {
      router.replace('/board');
    },
    children: t['back.home']
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    loading: loading,
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().wrapper),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().result),
        children: [error.bg, error.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().title),
          children: error.title
        }), error.subTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().subtitle),
          children: error.subTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", _objectSpread({
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().btn)
        }, buttonProps)), isNotVerified && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: `${(_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().btn)} ${(_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default()["outline-btn"])}`,
          onClick: () => {
            router.replace('/board').then(() => {
              window.location.reload();
            });
          },
          children: t['btn.verify_already']
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Exception);

/***/ }),

/***/ 33241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "Nw": function() { return /* binding */ actions; },
/* harmony export */   "ZP": function() { return /* binding */ reducer; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const actionTypes = {
  updateCollectionStore: Symbol('updateCollectionStore')
};
const actions = {
  updateCollectionStore: payload => ({
    type: actionTypes.updateCollectionStore,
    payload
  })
};
const initialState = {
  group: {
    influencers: [],
    lives: [],
    products: [],
    sellers: [],
    videos: []
  }
};
function reducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.updateCollectionStore:
      {
        return _objectSpread(_objectSpread({}, state), action.payload);
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 26638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ updateVersionData; },
/* harmony export */   "I_": function() { return /* binding */ updateSearchType; },
/* harmony export */   "JD": function() { return /* binding */ updateVersionDataLoading; },
/* harmony export */   "YS": function() { return /* binding */ wrapper; },
/* harmony export */   "kD": function() { return /* binding */ updateProductNameTranslate; },
/* harmony export */   "kS": function() { return /* binding */ updateVersionModalVisible; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14890);
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49780);
/* harmony import */ var _collection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33241);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28858);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1405);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const initialState = {
  userLoading: true,
  userInfo: {},
  version: '',
  versionData: {
    version: '',
    date: '',
    title: '',
    description: [],
    banners: [],
    changelog: '',
    headlines: []
  },
  versionModalVisible: false,
  versionDataLoading: false,
  redsList: [],
  productNameTranslate: false,
  searchType: '1'
};

function global() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'update-userInfo':
      {
        const {
          userInfo = state.userInfo,
          userLoading = false
        } = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          userLoading,
          userInfo
        });
      }

    case 'update-version':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          version: action.payload
        });
      }

    case 'update-reds-list':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          redsList: action.payload
        });
      }

    case 'update-product-name-translate':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          productNameTranslate: action.payload
        });
      }

    case 'update-version-data':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          versionData: action.payload
        });
      }

    case 'update-version-modal-visible':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          versionModalVisible: action.payload
        });
      }

    case 'update-version-data-loading':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          versionDataLoading: action.payload
        });
      }

    case 'update-search-type':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          searchType: action.payload
        });
      }

    default:
      return state;
  }
}

const combinedReducer = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .combineReducers */ .UY)({
  global,
  ssr: _ssr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP,
  collection: _collection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP
});

const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    global: initialState,
    ssr: _ssr__WEBPACK_IMPORTED_MODULE_1__/* .initialState */ .E3,
    collection: _collection__WEBPACK_IMPORTED_MODULE_2__/* .initialState */ .E3
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;

  // 仅有 ssr reducer 是在服务端渲染时产生 state ，所以在注水时仅注水 ssr reducer
  if (action.type === next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .HYDRATE */ .ju) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ssr: action.payload.ssr
    });
  } else {
    return combinedReducer(state, action);
  }
};

const wrapper = (0,next_redux_wrapper__WEBPACK_IMPORTED_MODULE_3__/* .createWrapper */ .KV)(() => (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)(reducer, !_utils_is__WEBPACK_IMPORTED_MODULE_4__/* .isSSR */ .yF && false ? 0 : undefined)); // Action creators

const updateProductNameTranslate = isTranslate => ({
  type: 'update-product-name-translate',
  payload: isTranslate
});
const updateVersionData = versionData => ({
  type: 'update-version-data',
  payload: versionData
});
const updateVersionModalVisible = visible => ({
  type: 'update-version-modal-visible',
  payload: visible
});
const updateVersionDataLoading = loading => ({
  type: 'update-version-data-loading',
  payload: loading
});
const updateSearchType = searchType => ({
  type: 'update-search-type',
  payload: searchType
});

/***/ }),

/***/ 49780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "Nw": function() { return /* binding */ actions; },
/* harmony export */   "ZP": function() { return /* binding */ reducer; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88028);
/* harmony import */ var _utils_language__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39080);
/* harmony import */ var _utils_region__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37101);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const actionTypes = {
  updateSsrStore: Symbol('updateSsrStore')
};
const actions = {
  updateSsrStoreAction: payload => ({
    type: actionTypes.updateSsrStore,
    payload
  })
};
const initialState = {
  lang: _utils_language__WEBPACK_IMPORTED_MODULE_2__/* .Language.enUS */ .S.enUS,
  currency: _utils_currency__WEBPACK_IMPORTED_MODULE_1__/* .Currency.US */ .F.US,
  region: _utils_region__WEBPACK_IMPORTED_MODULE_3__/* .Region.US */ .y.US,
  secondaryCurrency: _utils_currency__WEBPACK_IMPORTED_MODULE_1__/* .SecondaryCurrency.CN */ .$g.CN,
  token: '',
  dataUpdateTime: 0,
  regionsData: {},
  enableRegions: [],
  isMobile: false,
  host: '',
  showMemberModal: false,
  memberModalClosable: true,
  ua: ''
};
function reducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.updateSsrStore:
      {
        return _objectSpread(_objectSpread({}, state), action.payload);
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 43397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ LiveStatus; },
/* harmony export */   "Eo": function() { return /* binding */ videoLeaderboardTabKeys; },
/* harmony export */   "IH": function() { return /* binding */ productsLeaderboardTabKeys; },
/* harmony export */   "Jr": function() { return /* binding */ favoritesTabKeys; },
/* harmony export */   "OM": function() { return /* binding */ MemberEdition; },
/* harmony export */   "SL": function() { return /* binding */ SellerTypes; },
/* harmony export */   "Wg": function() { return /* binding */ userTabKeys; },
/* harmony export */   "_L": function() { return /* binding */ InfluencerCertificateTypes; },
/* harmony export */   "ai": function() { return /* binding */ SearchTypes; },
/* harmony export */   "bZ": function() { return /* binding */ UserTypes; },
/* harmony export */   "c": function() { return /* binding */ CollectStatus; },
/* harmony export */   "cd": function() { return /* binding */ searchTypeEnum; },
/* harmony export */   "iF": function() { return /* binding */ OrderStatus; },
/* harmony export */   "oY": function() { return /* binding */ SortTypeEnum; },
/* harmony export */   "zG": function() { return /* binding */ influencersLeaderboardTabKeys; }
/* harmony export */ });
/* unused harmony exports liveLeaderboardTabKeys, shopLeaderboardTabKeys, analysisTabKeys */
const searchTypeEnum = {
  //达人
  Influencer: 'influencer',
  // 商品
  Products: 'products',
  // 视频
  Videos: 'videos',
  // 直播
  Lives: 'lives',
  // 小店
  Shops: 'shops'
};
const SortTypeEnum = {
  // 升序
  Asc: 'asc',
  // 降序
  Desc: 'desc'
};
let LiveStatus;

(function (LiveStatus) {
  LiveStatus[LiveStatus["Over"] = 0] = "Over";
  LiveStatus[LiveStatus["InProgress"] = 1] = "InProgress";
})(LiveStatus || (LiveStatus = {}));

let CollectStatus;

(function (CollectStatus) {
  CollectStatus[CollectStatus["UnStar"] = 0] = "UnStar";
  CollectStatus[CollectStatus["Star"] = 1] = "Star";
})(CollectStatus || (CollectStatus = {}));

let InfluencerCertificateTypes;

(function (InfluencerCertificateTypes) {
  InfluencerCertificateTypes[InfluencerCertificateTypes["None"] = 0] = "None";
  InfluencerCertificateTypes[InfluencerCertificateTypes["Personal"] = 1] = "Personal";
  InfluencerCertificateTypes[InfluencerCertificateTypes["Enterprise"] = 2] = "Enterprise";
})(InfluencerCertificateTypes || (InfluencerCertificateTypes = {}));

let SearchTypes;

(function (SearchTypes) {
  SearchTypes[SearchTypes["Influencer"] = 0] = "Influencer";
  SearchTypes[SearchTypes["Product"] = 1] = "Product";
  SearchTypes[SearchTypes["Video"] = 2] = "Video";
  SearchTypes[SearchTypes["Live"] = 3] = "Live";
  SearchTypes[SearchTypes["Shop"] = 4] = "Shop";
  SearchTypes[SearchTypes["Hashtag"] = 5] = "Hashtag";
})(SearchTypes || (SearchTypes = {}));

let SellerTypes;

(function (SellerTypes) {
  SellerTypes[SellerTypes["Local"] = 1] = "Local";
  SellerTypes[SellerTypes["CrossBorder"] = 2] = "CrossBorder";
})(SellerTypes || (SellerTypes = {}));

let UserTypes;

(function (UserTypes) {
  UserTypes[UserTypes["Unknown"] = -1] = "Unknown";
  UserTypes[UserTypes["Internal"] = 0] = "Internal";
  UserTypes[UserTypes["Normal"] = 1] = "Normal";
  UserTypes[UserTypes["Proxy"] = 2] = "Proxy";
})(UserTypes || (UserTypes = {}));

const MemberEdition = {
  Free: 'free',
  Basic: 'basic',
  Pro: 'pro',
  Enterprise: 'enterprise'
};
let OrderStatus;

(function (OrderStatus) {
  OrderStatus[OrderStatus["Created"] = 10] = "Created";
  OrderStatus[OrderStatus["Paid"] = 20] = "Paid";
  OrderStatus[OrderStatus["Closed"] = 100] = "Closed";
  OrderStatus[OrderStatus["Refunded"] = 30] = "Refunded";
})(OrderStatus || (OrderStatus = {}));

const influencersLeaderboardTabKeys = {
  followers: 'followers',
  followerGrowth: 'follower-growth',
  salesChampion: 'sales-champion',
  darkHorseCreators: 'dark-horse-creators',
  darkHorseSellers: 'dark-horse-sellers',
  hotLive: 'hot-live',
  mostViewsLive: 'most-views-live'
};
const productsLeaderboardTabKeys = {
  topSold: 'top-sold',
  hotPromoted: 'hot-sell',
  newProducts: 'new-products'
};
const liveLeaderboardTabKeys = {
  mostViewed: 'most-viewed',
  topSold: 'top-sold',
  live: 'live'
};
const shopLeaderboardTabKeys = {
  local: 'local',
  crossBorder: 'cross-border'
};
const favoritesTabKeys = {
  influencers: 'influencers',
  videos: 'videos',
  products: 'products',
  lives: 'lives',
  shops: 'shops'
};
const analysisTabKeys = {
  influencers: 'influencers',
  products: 'products',
  country: 'country'
};
const videoLeaderboardTabKeys = {
  topVideos: 'top-videos',
  topSellingVideos: 'top-selling-videos',
  topHashtags: 'top-hashtags'
};
const userTabKeys = {
  setting: 'setting',
  invite: 'invite',
  bill: 'bill',
  team: 'team'
};

/***/ }),

/***/ 1893:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__2mWfV","result":"index_result__sMJ4T","title":"index_title__PttsY","subtitle":"index_subtitle__gC2zi","btn":"index_btn__kx1CK","bg500":"index_bg500__o6eHZ","bg404":"index_bg404__weRl7","bg403":"index_bg403__5sGM5"};

/***/ }),

/***/ 83599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__QkZTf","modal":"index_modal__J1Wgk","close":"index_close__qLpgD"};

/***/ }),

/***/ 9205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__BUzaN","result":"index_result__pglHe","title":"index_title__Wtn46","subtitle":"index_subtitle__lNfwA","btn":"index_btn__NhRGm","outline-btn":"index_outline-btn__s76zB"};

/***/ }),

/***/ 21426:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);